import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import _ from 'lodash';
import {
  Grid
} from '@mui/material';
import { AutocompleteV } from 'components';
import {  formatPrice } from 'utility';
import { CircularProgress } from '@mui/material';
import { useStyles } from './style';

const AccountsSelectBox = (props) => {
  // --PROPS--//
  const {
    balance,
    methods,
    singleSelect = false,
    selected = [],
    setSelected = () => { },
    className,
    style,
    showBalance = true,
    disableNoBalances = false,
    placeholder = 'جستجو و انتخاب کنید...',
    label = 'حساب‌های تفصیلی کسب‌وکار',
    name = 'guilds',
    currencyText,
    ...rest
  } = props;

  // --STATES--//
  const [guildSearchText, setGuildSearchText] = useState('');
  const [guildsList, setGuildsList] = useState([]);
  const [guildListLoading, setGuildListLoading] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  // --HOOKS--//
  const classes = useStyles();

  useEffect(() => {
    const getGuildsList = () => {
      setGuildListLoading(true);

      try {
        const data = Array.isArray(balance?.mainBusinessAmountSrvs)
          ? balance.mainBusinessAmountSrvs
          : [];
        const list = data.map((val) => ({
            name:
              (val?.aliasName ?? val?.guildSrv?.name) +
              (showBalance
                ? ` (قابل برداشت: ${val?.withdrawableAmount != null
                  ? formatPrice(val?.withdrawableAmount, { currency: currencyText }) 
                  : '-'
                })`
                : ''),
            id: val.id,
            label:
              (val?.aliasName ?? val?.guildSrv?.name) +
              (showBalance
                ? ` (قابل برداشت: ${val?.withdrawableAmount != null
                  ? formatPrice(val?.withdrawableAmount, { currency: currencyText }) 
                  : '-'
                })`
                : ''),
            value: val.id,
            code: val?.guildSrv?.code,
            currency: val?.currencySrv,
            balance: val?.withdrawableAmount ?? 0,
          }));

        setGuildsList(list);
      } catch (error) {
        setGuildsList([]);
      } finally {
        setGuildListLoading(false);
      }
    };

    getGuildsList();
  }, [balance?.mainBusinessAmountSrvs, currencyText, showBalance]);


  return (
    <Grid item xs={12} >
      <Grid item xs={12} className={clsx(classes.root, className)} style={{ position: 'relative' }}>
        <AutocompleteV
          disabled={isLoading}
          style={(isLoading) ? { backgroundColor: 'rgb(237 237 237)' } : {}}
          control={methods?.control}
          errors={methods?.errors}
          register={methods?.register}
          placeholder={placeholder}
          name={name}
          label={label}
          list={guildsList}
          loading={guildListLoading}
          inputValue={singleSelect ? undefined : guildSearchText}
          getOptionSelected={(option, value) => option.id === value.id}
          getOptionDisabled={(option) =>
            (singleSelect
              ? selected?.value === option?.value
              : selected?.find((v) => v?.id === option?.id) != null) ||
            (option?.balance === 0 && disableNoBalances)
          }
          onChangeValue={(p) => {
           
            setGuildSearchText('');
            if (!p) return;
            if (singleSelect) {
              setSelected(p);
            } else {
              const temp = [...selected];
              temp.push(p);
              setSelected([...temp]);
            }
            if (methods?.setValue) {
              methods.setValue(name, p, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true,
              });
            }
          }}
          preventAddCustomOption
          disableClearable

          {...rest}
        />
        {
          isLoading &&
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>

            <CircularProgress size={18} style={{ position: 'absolute', top: '40px' }} />
          </div>
        }
      </Grid>
    </Grid>
  );
};

export default AccountsSelectBox;
